import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary font-sans selection:bg-brand-primary selection:text-black">
      <Navbar />
      <div className="pt-32 pb-24 px-6 lg:px-[7.69%] max-w-[1000px] mx-auto">
        <h1 className="display-large mb-8 text-brand-primary">Privacy Policy</h1>
        <p className="body-medium text-text-muted mb-8">Last Updated: August 2025</p>

        <div className="space-y-8 body-medium text-text-secondary">
          <section>
            <h2 className="heading-2 text-white mb-4">1. Introduction</h2>
            <p>Falcon42 ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">2. Data We Collect</h2>
            <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
              <li><strong>Contact Data:</strong> includes billing address, delivery address, email address and telephone numbers.</li>
              <li><strong>Technical Data:</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform.</li>
              <li><strong>Usage Data:</strong> includes information about how you use our website, products and services.</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">3. How We Use Your Data</h2>
            <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
              <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
              <li>Where we need to comply with a legal or regulatory obligation.</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">4. Data Security</h2>
            <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.</p>
          </section>

          <section>
            <h2 className="heading-2 text-white mb-4">5. Contact Details</h2>
            <p>If you have any questions about this privacy policy or our privacy practices, please contact us at:</p>
            <div className="mt-4 p-4 border border-border-subtle bg-bg-secondary">
              <p><strong>Falcon42</strong></p>
              <p>245, 4 Peddlers Row</p>
              <p>Newark, DE 19702</p>
              <p>EIN: 37-2144924</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
